<div [mmTestId]="'ORDER_HISTORY.ORDER_LINE_ACTIONS_BAR'"
     class="actions-bar">
  <app-link-ga-tracking [toolTip]="orderLine?.product?.name"
                           [linkType]="'link'"
                           [redirectLink]="'/' + APP_PRODUCT_ROUTE + '/' + orderLine?.product?.productId"
                           [isLinkDisabled]="isSubsidiaryAccount"
                           [label]="orderLine?.product?.name">
  </app-link-ga-tracking>

  <div class="actions-bar__btns">
    <ng-container *ngIf="!isMobileOrTablet">
      <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
    </ng-container>

    <button *ngIf="shouldShowContextMenu"
            mm-button
            [color]="'secondary'"
            [size]="'small'"
            [iconButton]="true"
            mmContextualMenu
            [mmContent]="contextMenuTemplate"
            mmPlacement="bottomRight"
            [mmTrigger]="menuTrigger.hover"
            class="actions-bar__ellipsis-btn"
            [mmTestTarget]="'order-line-action-menu'"
            type="button"
    >
      <mm-icon name="dot-three-horizontal"></mm-icon>
    </button>
  </div>
</div>

<ng-container *ngIf="isMobileOrTablet">
  <ng-container *ngTemplateOutlet="actionButtons; context: { fluid: true }"></ng-container>
</ng-container>

<ng-template #contextMenuTemplate>
  <mm-contextual-menu-item *ngIf="isAllowedOpenReturnInstructions"
                           (click)="openReturnInstructionsDialog()"
                           [mmTestTarget]="'return-instructions'">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_INSTRUCTIONS' | translate }}
  </mm-contextual-menu-item>

  <ng-container *ngIf="isAllowedReturnProduct">
    <div [mmTooltip]="returnBtnTooltipContent"
         [mmTooltipDisabled]="orderLine?.allowedTransitions?.requestReturn">
      <mm-contextual-menu-item [mmTestTarget]="'return-order-line'"
                               [disabled]="!orderLine?.allowedTransitions?.requestReturn"
                               color="warning"
                               (click)="returnProduct()">
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_PRODUCT' | translate }}
      </mm-contextual-menu-item>
    </div>
  </ng-container>
  <ng-template #returnBtnTooltipContent>
    <p class="product-line__tooltip">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_RETURN_PRODUCT_TOOLTIP' | translate }}
    </p>
  </ng-template>

  <mm-contextual-menu-item *ngIf="isAllowedCancelReturning"
                           color="warning"
                           [mmTestTarget]="'cancel-return-order-line'"
                           (click)="cancelReturn()">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_CANCEL_RETURN_PRODUCT' | translate }}
  </mm-contextual-menu-item>

  <div *ngIf="isAllowedDownloadReturnLabel"
       [mmTooltip]="returnLabelTooltipContent"
       [mmTooltipDisabled]="orderLine?.documents?.returnLabels?.length">
    <mm-contextual-menu-item [disabled]="!orderLine?.documents?.returnLabels?.length"
                             (click)="downloadFiles(orderLine?.documents?.returnLabels, docTypes.RETURN_LABEL)"
                             [mmTestTarget]="'download-return-labels'">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_RETURN_LABEL' | translate }}
    </mm-contextual-menu-item>
  </div>
</ng-template>

<ng-template #invoiceTooltipContent>
  <p class="actions-bar__tooltip">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_INVOICE_HINT' | translate }}
  </p>
</ng-template>

<ng-template #returnLabelTooltipContent>
  <p class="actions-bar__tooltip">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_RETURN_LABEL_HINT' | translate }}
  </p>
</ng-template>

<ng-template #contactSellerTooltip>
  <p class="actions-bar__tooltip">
    {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_CONTACT_SELLER' | translate }}
  </p>
</ng-template>

<ng-template #actionButtons
             let-fluid="fluid">
  <div *ngIf="isAllowedDownloadInvoicesDocs && !isSubsidiaryAccount"
       class="actions-bar__action-btn"
       [mmTooltip]="invoiceTooltipContent"
       [mmTooltipDisabled]="isInvoiceDocumentsAttached">
    <button mm-button
            [color]="'primary'"
            [disabled]="!isInvoiceDocumentsAttached"
            (click)="downloadInvoices()"
            [fluid]="fluid"
            [mmTestTarget]="'download-invoices'">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_DOWNLOAD_INVOICE' | translate }}
    </button>
  </div>
  <div *ngIf="isAllowedCancelProduct"
       class="actions-bar__action-btn actions-bar__action-btn--warning">
    <button mm-button
            [fluid]="fluid"
            color="ghost-warning"
            [mmTestTarget]="'cancel-product'"
            (click)="cancelOrderLine()">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.BUTTON_CANCEL_PRODUCT' | translate }}
    </button>
  </div>
</ng-template>
